import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Generator from "@/pages/Generator";
import Atelier from "@/pages/Atelier";
import Creer from "@/pages/Creer";
import CreativeStudio from "@/pages/CreativeStudio";
import CalendarPage from "@/pages/CalendarPage";
import Posts from "@/pages/Posts";
import Admin from "@/pages/Admin";
import AdminConferences from "@/pages/AdminConferences";
import AdminGroupPages from "@/pages/AdminGroupPages";
import BrandKit from "@/pages/BrandKit";
import Veille from "@/pages/Veille";
import Tarifs from "@/pages/Tarifs";
import Parrainage from "@/pages/Parrainage";
import About from "@/pages/About";
import Invitation from "@/pages/Invitation";
import AffiliationSignup from "@/pages/Affiliation";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Confidentialite from "@/pages/Confidentialite";
import ConfirmEmail from "@/pages/ConfirmEmail";
import Layout from "@/components/Layout";
import { captureRef } from "@/lib/ref";

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-coral font-display font-bold text-2xl animate-pulse">Pulse…</div>
    </div>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { captureRef(); }, []);
  if (loading) return <Spinner />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/invitation" element={<Invitation />} />
      <Route path="/affiliation" element={<AffiliationSignup />} />
      <Route path="/apropos" element={<About />} />
      <Route path="/mentions" element={<Legal type="mentions" />} />
      <Route path="/cgu" element={<Legal type="cgu" />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/confirmer-email" element={<ConfirmEmail />} />
      {user ? (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="onboarding" element={<Onboarding />} />
          <Route path="marque" element={<BrandKit />} />
          <Route path="creer" element={<Creer />} />
          <Route path="atelier" element={<Atelier />} />
          <Route path="generer" element={<Generator />} />
          <Route path="studio" element={<CreativeStudio />} />
          <Route path="veille" element={<Veille />} />
          <Route path="tarifs" element={<Tarifs />} />
          <Route path="parrainage" element={<Parrainage />} />
          <Route path="calendrier" element={<CalendarPage />} />
          <Route path="posts" element={<Posts />} />
          <Route path="admin" element={<Admin />} />
          <Route path="admin/conferences" element={<AdminConferences />} />
          <Route path="admin/conferences/groupes" element={<AdminGroupPages />} />
        </Route>
      ) : (
        <Route path="/" element={<Home />} />
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
